import { render, staticRenderFns } from "./AddImageComponent.vue?vue&type=template&id=3779f573&lang=pug&"
import script from "./AddImageComponent.vue?vue&type=script&lang=js&"
export * from "./AddImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports